import React, { Component } from "react";
import Select from "react-select";
import { SkyLightStateless } from 'react-skylight';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import _ from 'lodash';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import ReactDataGrid from "react-data-grid";

import axios from 'axios';
import {
  ROOT_URL, //https://abc-scm.truckxi.com/api/
} from '../../../../actions/root_url';
import { DateFormatter } from '../../dateFormat';

const fetchMonitorOrdersAPI = (warehouse_id, success, failed) => {
  axios({
    method: 'GET',
    url: `${ROOT_URL}v1/sale/monitor_order`,
    params: {
      warehouse_id,
    },
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
  })
    .then(res => {
      success(res.data);
    }, err => {
      console.log('err', err);
    })
}

const updateMonitorOrderNotation = (salesorderId, data, success, failed) => {
  axios({
    method: 'PUT',
    url: `${ROOT_URL}v1/sale/monitor_order/${salesorderId}`,
    data,
    headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
  })
    .then(res => {
      console.log('res', res);
      success();
    }, err => {
      console.log('err', err);
    })
}


const modalStyle = {
  width: '1000px',
  height: '600px',
  marginLeft: '-28%',
  marginTop: '-18%',
}

const propTypes = {
  setModalVisibility: PropTypes.func.isRequired,
  isVisible: PropTypes.bool,
}

const defaultProps = {
  setModalVisibility: () => { },
  isVisible: false,
}

class MonitorList extends Component {
  state = {
    monitorOrders: [],
  }

  componentDidMount() {
    this.fetchMonitorOrders();
  }

  fetchMonitorOrders = () => {
    const success = (monitorOrders = []) => {
      this.setState({
        monitorOrders,
      })
    }
    const failed = () => {
      console.log('faield');
    }
    const warehouse_id = this.props.selectedWarehouse.value || this.props.selectedWarehouse;

    fetchMonitorOrdersAPI(warehouse_id, success, failed);
  }

  handleCloseClick = () => {
    this.props.setModalVisibility();
  }

  renderMonitorOrdersTable = () => {
    const getRows = () => Data.Selectors.getRows({ rows: this.state.monitorOrders });
    const getSize = () => getRows().length;
    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };



    const columns = [{
      key: 'SalesOrderNo',
      name: <Translate value="so_num" />,
      resizable: true,
      sortable: true,
      // width: 200,
      filterable: true,
    }, {
      key: 'StoreName',
      name: <Translate value="store_name" />,
      resizable: true,
      sortable: true,
      // width: 200,
      filterable: true,
    }, {
      key: 'Notation',
      name: <Translate value="notation" />,
      resizable: true,
      sortable: true,
      // width: 200,
      filterable: true,
      editable: true,
    }, {
      key: 'CreatedBy',
      name: <Translate value="create_by" />,
      resizable: true,
      sortable: true,
      // width: 200,
      filterable: true,
    }, {
      key: 'CreateTime',
      name: <Translate value="create_date" />,
      resizable: true,
      sortable: true,
      // width: 200,
      filterable: true,
      formatter: DateFormatter
    }];

    const handleRowUpdated = (info) => {
      const { key, rowIdx, updated } = info;
      console.log('info', info);
      if (key === 'Enter') {
        const id = rowGetter(rowIdx).id;
        const data = {
          ...updated,
        };
        const success = () => {
          this.fetchMonitorOrders();
        }
        updateMonitorOrderNotation(id, data, success)
      }
    }

    return (
      <Row>
        <Col xs={12}>
          <ReactDataGrid
            rowKey="SalesOrder_id"
            columns={columns}
            rowHeight={25}
            headerRowHeight={45}
            rowGetter={rowGetter}
            rowsCount={getSize()}
            enableCellSelect={true}
            onRowUpdated={handleRowUpdated}
            toolbar={<Toolbar enableFilter />}
          // minHeight={500}
          />
        </Col>
      </Row>
    )
  }
  render() {
    return (
      <div style={{ width: '100%', height: '100%', padding: '10px' }}>
        {this.renderMonitorOrdersTable()}
        <div style={{ position: 'absolute', bottom: '30px', right: '20px' }}>
          <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            onClick={() => {
              this.handleCloseClick();
            }}
          >
            <Translate value="close" />
          </Button>
        </div>
      </div>
    )
  }
}

const MonitorListModal = ({ setModalVisibility, isVisible, selectedWarehouse }) => (
  <SkyLightStateless
    title={'Monitor Order List'}
    onCloseClicked={setModalVisibility}
    dialogStyles={modalStyle}
    isVisible={isVisible}
  >
    <MonitorList setModalVisibility={setModalVisibility} isVisible={isVisible} selectedWarehouse={selectedWarehouse} />
  </SkyLightStateless>
)

MonitorListModal.propTypes = propTypes
MonitorListModal.defaultProps = defaultProps

export default MonitorListModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/MonitorListModal.jsx